import { atom } from 'jotai';
import { atomWithReset } from 'jotai/utils';

export function getOmnitagResultJobStatusKey(
  logName: string,
  timestamp: string | number
): string {
  return logName + timestamp.toString();
}

/** Keys of items known to have been sent to annotations. Used for hide-sent-items filtering. */
export const sentItemKeysAtom = atomWithReset<Set<string>>(new Set());

/** This is so filtering can be done that excludes 'sent' items */
export const addSentItemKeyAtom = atom(null, (get, set, key: string): void => {
  const current = get(sentItemKeysAtom);
  if (current.has(key)) {
    return;
  }
  set(sentItemKeysAtom, new Set([...current, key]));
});
